module.exports = __webpack_public_path__ + "wood_head.png?4b8da42613c7d9953413d6b75d652f44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood_head.png
// module id = 63
// module chunks = 0